import styled from 'styled-components';

export const WrapperButtons = styled.div`
display: flex;
flex-direction: row;
justify-content: space-between;
align-items: center;
`

export const InputWrapper = styled.div`
    position: relative;
    width: 100px;
    display: inline-block;
`;

export const Input = styled.input`
    width: 90%;
    padding-right: 30px;
    box-sizing: border-box;
    text-align: center;
    border: 1px solid var(--Blues-Blue-3, #99B7EF);
    border-radius: 4px;
    height: 48px;
`;

export const InputDays = styled.input`
    width: 90%;
    
    box-sizing: border-box;
    text-align: center;
    border: 1px solid var(--Blues-Blue-3, #99B7EF);
    border-radius: 4px;
    height: 48px;
`;

export const ArrowButton = styled.button`
    position: absolute;
    right: 19px;
    width: 20px;
    height: 15px;
    font-size: 10px;
    cursor: pointer;
    border: none;
    background: transparent;
    border-radius: 2px;
    &:first-of-type {
        top: 5px;
    }

    &:last-of-type {
        bottom: 5px;
    }

    &:hover {
        background-color: #e0e0e0;
    }
`;

export const TextMessageWrapper = styled.div`
    background-color: #f3f6f9;
    
`;
export const TextAreaMessage = styled.textarea`
    width: 100%;
    font-family: var(--EasyCareTextAreaMessageFont-family);
    border-radius: 4px;
    height: 205px;
    padding: 12px 20px;
    background-color: transparent;
    border: none;
    resize: none;
    color:#002E5C;
`

export const TextMessagesList = styled.div`
    border-top: 1px solid #B5B5C3;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: .5rem;
    padding: 20px;
    width: 100%;
`
export const TextMessageItem = styled.div`
    border: ${props => props.active ? 'none' : '1px solid #B5B5C3'};
    background-color: ${props => props.active ? '#D3DDFC' : '#F9FAFB'};
    color: ${props => props.active ? '#2555EF' : '#667085'};
    padding: 5px 10px;
    box-shadow: 0px 1px 2px 0px #1018280D;
    border-radius: 4px;
    cursor: pointer;
`
